import React from 'react';
import { Control, Controller, FieldErrorsImpl, RegisterOptions } from 'react-hook-form';
import { Typography } from '@navi/web-ui/lib/primitives';
import ErrorIconOutline from '@cp/src/assets/icons/ErrorIconOutline';
import Dropdown from '@cp/src/components/Dropdown';
import cx from 'classnames';
import RequiredIcon from '@navi/web-ui/lib/icons/RequiredIcon';
import { AgentFormValues } from '../../interfaces/types';
import { IOption } from '@cp/src/components/FilterDrawer/types';

type AgentFormDropdownProps = {
  control: Control<AgentFormValues, any>;
  name: keyof AgentFormValues;
  rules: RegisterOptions;
  errors: Partial<FieldErrorsImpl<AgentFormValues>>;
  isEditDisabled: boolean | undefined;
  styles: CSSModuleClasses;
  inputLabel: string;
  placeholder: string;
  validationMessage: string;
  options: IOption[];
  defaultSelected: any;
  showRequiredIcon?: boolean;
};

const AgentFormDropdown: React.FC<AgentFormDropdownProps> = props => {
  const {
    control,
    name,
    rules,
    errors,
    isEditDisabled,
    styles,
    validationMessage,
    inputLabel,
    placeholder,
    options,
    defaultSelected,
    showRequiredIcon = true
  } = props;

  return (
    <>
      <div className={cx(styles.textContainer, 'pb-1')}>
        <Typography variant="p4" color="var(--navi-color-gray-c2)">
          {inputLabel}
        </Typography>
        {showRequiredIcon ? <RequiredIcon /> : null}
      </div>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field: { onChange } }) => (
          <Dropdown
            placeholder={placeholder}
            placeholderColor={'var(--navi-color-gray-c3)'}
            showSolidArrow={true}
            arrowIconWidth={9}
            options={options}
            onSelectionChange={e => {
              onChange(e.value);
            }}
            defaultSelected={defaultSelected}
            containerClasses={styles.dropdownContainer}
            disabled={isEditDisabled}
            error={errors && errors[name] && errors[name].message}
            pickerContainerClasses={'max-h-[266px]'}
            showTextCursorOnDisabled={true}
            tabIndexEnabled={true}
          />
        )}
      />
      {errors && errors[name] && (
        <div className={styles.errorContainer}>
          <ErrorIconOutline />
          <Typography variant="p4" className={styles.errorText}>
            {validationMessage}
          </Typography>
        </div>
      )}
    </>
  );
};

export default AgentFormDropdown;
